import Service, {parseParams} from 'api';

export const list = (params = {}, config) => {
  const parsedParams = parseParams({
    sort: 'name',
    limit: 0,
    ...params,
  });

  return Service.get(`terms_and_conditions?${parsedParams}`, config);
};

export const post = (data = {}, config = {}) => Service.post('terms_and_conditions', data, config);
export const put = (id, data = {}, config = {}) => Service.put(`terms_and_conditions/${id}`, data, config);
export const destroy = (id, config) => Service.delete(`terms_and_conditions/${id}`, config);
